import { SectionTitle } from '@elotech/components';
import PropTypes from 'prop-types';
import React from 'react';

import IdentificacaoSectionList from './IdentificacaoSectionList';

const Identificacao = ({
  dadosIdentificacao,
  adicionarComprador,
  editarComprador,
  deletarComprador,
  adicionarVendedor,
  editarVendedor,
  deletarVendedor,
  adicionarAnuente,
  editarAnuente,
  deletarAnuente,
  adicionarProprietarioCidadao,
  editarProprietarioCidadao,
  deletarProprietarioCidadao,
  onSetPrincipalCidadao,
  permiteEditarProprietario,
  permiteDeletarProprietario,
  user,
  requerente,
  anuencia,
  vinculos,
  onViewPessoa,
  isServidor,
  validaRgComprador,
  onChangePrincipal,
  utilizaFluxoAutonomiaCidadao,
  utilizaItbiMaisFacil,
  utilizaTramitacaoAutomatica,
  disabled = false
}) => {
  return (
    <div>
      <SectionTitle>Identificação</SectionTitle>
      <div
        style={{
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.6 : 1
        }}
      >
        <IdentificacaoSectionList
          list={dadosIdentificacao.compradores}
          vendedores={dadosIdentificacao.vendedores}
          title="Comprador"
          adicionar={adicionarComprador}
          editar={editarComprador}
          onDelete={deletarComprador}
          comprador
          user={user}
          requerente={requerente}
          vinculos={vinculos}
          onViewPessoa={onViewPessoa}
          isServidor={isServidor}
          validaRgComprador={validaRgComprador}
          onChangePrincipal={onChangePrincipal}
          utilizaFluxoAutonomiaCidadao={utilizaFluxoAutonomiaCidadao}
        />
        <div className="mt-xs" />
        <IdentificacaoSectionList
          list={dadosIdentificacao.vendedores}
          compradores={dadosIdentificacao.compradores}
          title="Vendedor"
          adicionar={adicionarVendedor}
          editar={editarVendedor}
          onDelete={deletarVendedor}
          vendedor
          vinculos={vinculos}
          onViewPessoa={onViewPessoa}
          isServidor={isServidor}
        />
        <div className="mt-xs" />
        {anuencia && (
          <IdentificacaoSectionList
            list={dadosIdentificacao.anuentes}
            vendedores={dadosIdentificacao.vendedores}
            compradores={dadosIdentificacao.compradores}
            title="Anuente/Cedente"
            adicionar={adicionarAnuente}
            editar={editarAnuente}
            onDelete={deletarAnuente}
            anuente
            vinculos={vinculos}
            onViewPessoa={onViewPessoa}
            isServidor={isServidor}
          />
        )}
        {(utilizaTramitacaoAutomatica ||
          (!isServidor &&
            (utilizaFluxoAutonomiaCidadao || utilizaItbiMaisFacil))) && (
          <>
            <div className="mt-xs" />
            <IdentificacaoSectionList
              list={dadosIdentificacao.proprietarios}
              title="Novo quadro de proprietários"
              adicionar={adicionarProprietarioCidadao}
              editar={editarProprietarioCidadao}
              onDelete={deletarProprietarioCidadao}
              proprietario
              vinculos={vinculos}
              onViewPessoa={onViewPessoa}
              isServidor={isServidor}
              onChangePrincipal={onSetPrincipalCidadao}
              utilizaFluxoAutonomiaCidadao={utilizaFluxoAutonomiaCidadao}
              utilizaItbiMaisFacil={utilizaItbiMaisFacil}
              utilizaTramitacaoAutomatica={utilizaTramitacaoAutomatica}
              permiteEditarProprietario={permiteEditarProprietario}
              permiteDeletarProprietario={permiteDeletarProprietario}
            />
          </>
        )}
      </div>
    </div>
  );
};

Identificacao.propTypes = {
  dadosIdentificacao: PropTypes.object.isRequired,
  adicionarComprador: PropTypes.func.isRequired,
  editarComprador: PropTypes.func.isRequired,
  deletarComprador: PropTypes.func.isRequired,
  adicionarVendedor: PropTypes.func.isRequired,
  editarVendedor: PropTypes.func.isRequired,
  deletarVendedor: PropTypes.func.isRequired,
  adicionarAnuente: PropTypes.func.isRequired,
  editarAnuente: PropTypes.func.isRequired,
  deletarAnuente: PropTypes.func.isRequired,
  adicionarProprietarioCidadao: PropTypes.func,
  editarProprietarioCidadao: PropTypes.func,
  deletarProprietarioCidadao: PropTypes.func,
  onSetPrincipalCidadao: PropTypes.func,
  permiteEditarProprietario: PropTypes.bool,
  permiteDeletarProprietario: PropTypes.bool,
  validaRgComprador: PropTypes.bool.isRequired,
  anuencia: PropTypes.bool,
  vinculos: PropTypes.array.isRequired,
  onChangePrincipal: PropTypes.func,
  utilizaFluxoAutonomiaCidadao: PropTypes.bool,
  utilizaItbiMaisFacil: PropTypes.bool,
  utilizaTramitacaoAutomatica: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Identificacao;
